/* eslint-disable */
import PropTypes from "prop-types";
import React from "react";
import "../../../../../styles/ComponentsStyles/Organizational/Management/Members/IndivisualMemberCard.style.css";
// import "../../../../"
const IndivisualMemberCard = ({
  image = "",
  name = "",
  profileId = "",
  designation = "",
  percentage = "",
  classSec = "",
}) => {
  return (
    <tr>
      <td>
        <div
          className="indivisualMemberProfileDetailsContainer"
          style={{ border: "none" }}
        >
          <img src={image} alt="profile image" />
          <div className="indivisualMemberProfileDetails">
            <h3>{name}</h3>
            <span>ID: {profileId}</span>
          </div>
        </div>
      </td>
      {designation !== "" && <td className="t-13">{designation}</td>}
      {classSec !== "" && <td className="color-gray t-13">{classSec}</td>}
      {percentage !== "" && <td className="t-13">{percentage}</td>}
    </tr>
  );
};

export default IndivisualMemberCard;
IndivisualMemberCard.propTypes = {
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  profileId: PropTypes.string.isRequired,
  designation: PropTypes.string,
  percentage: PropTypes.string.isRequired,
  classSec: PropTypes.string,
};
